<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<div class="content-page">
    <div class="content p-1 crumbs">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Borrowing Base Report</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    
    @if (security.permitted('reports', 'borrowing base', 'view')) {
        <aside>            
            <form [formGroup]="form">
                <div class="form-group">
                    <select class="form-control" name="lot" id="lot-filter" formControlName="lotId">
                        <option value="0">All Lots</option>
                        @for (lot of lots; track lot.id) {
                            <option value="{{lot.id}}">{{lot.contact.name}}</option>
                        }
                    </select>
                </div>
                <div class="form-group">
                    <select class="form-control" name="sum" id="sum-filter" formControlName="sum">
                        <option value="principal">Principal Balance</option>
                        <option value="principalwithtax">Principal + Tax Balance</option>
                        <option value="payment">Payment Balance</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="days-filter">Days Late Criteria</label>
                    <select class="form-control" name="days" id="days-filter" formControlName="days">
                        <option value="30">30 Days</option>
                        <option value="60">60 Days</option>
                        <option value="90">90 and Above</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="term-filter">Monthly Term Criteria</label>
                    <select class="form-control" name="term" id="term-filter" formControlName="term">
                        <option value="24">24 month (2 yr) terms</option>
                        <option value="36">36 month (3 yr) terms</option>
                        <option value="48">48 month (4 yr) terms</option>
                        <option value="60">60 month (5 yr) terms</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="percent-filter">Borrowing Base Percent</label>
                    <percent-input id="percent-filter" [control]="form.get('percent')"></percent-input>
                </div>
                <div class="form-group">
                    <label for="commitment-filter">Commitment</label>
                    <currency-input id="commitment-filter" [control]="form.get('commitment')"></currency-input>
                </div>
                <div class="form-group">
                    <label for="advances-filter">Outstanding Advances</label>
                    <currency-input id="advances-filter" [control]="form.get('advances')"></currency-input>
                </div>
            </form>
        </aside>

        <main>
            @if (summary && (summary.companyId)) {
                <h3>{{summary.company}}</h3>
                <h4 class="text-muted">{{summary.address}}</h4>
                <h4 class="text-muted">{{summary.cityStateZip}}</h4>
                <h5>Report as of {{summary.asOf | date:'E MMM d, yyyy'}}</h5>

                <h4>Calculation of Borrowing Base: {{summedBy}}</h4>

                <ul class="list-group list-group-horizontal justify-content-center flexed">
                    <li class="list-group-item"><span>Total Number of Accounts</span> <span>{{summary.count | number: '1.0-0'}}</span></li>
                </ul>

                <ol>
                    <li>
                        <div class="flexible">
                            <p>Total Finance Contracts</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{balance(summary, null) | currency}}</p>
                        </div>
                        <ul class="list-group flexed">
                            <li class="list-group-item"><span class="text-primary">Total Current {{summedBy}} Balance</span> <span>{{balance(summary, 'current') | currency}}</span></li>
                            <li class="list-group-item"><span class="text-primary">Total 30 Day {{summedBy}} Balance</span> <span>{{balance(summary, 'thirtyDay') | currency}}</span></li>
                            <li class="list-group-item"><span class="text-primary">Total 60 Day {{summedBy}} Balance</span> <span>{{balance(summary, 'sixtyDay') | currency}}</span></li>
                            <li class="list-group-item"><span class="text-primary">Total 90 Day {{summedBy}} Balance</span> <span>{{balance(summary, 'ninetyDay') | currency}}</span></li>
                            <li class="list-group-item item-total"><span>Total {{summedBy}} Balance</span> <span>{{balance(summary, null) | currency}}</span></li>
                        </ul>
                    </li>
                    <li>
                        <div class="flexible">
                            <p>Ineligible Finance Contracts</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{balance(ineligible.summary, null) | currency}}</p>
                        </div>
                    </li>
                    <ol type="a">
                        <li>
                            <div class="flexible">
                                <p>More than {{form.get('days').value}} days past due</p>
                                <span class="text-truncate">................................................................................................................................................................</span>
                                <p class="numeric">{{balance(ineligible.summary, null) | currency}}</p>
                            </div>
                        </li>
                        <li>
                            <div class="flexible">
                                <p>Financed auto borrower is insolvent or bankrupt</p>
                                <span class="text-truncate">................................................................................................................................................................</span>
                                <p class="numeric">{{0 | currency}}</p>
                            </div>
                        </li>
                        <li>
                            <div class="flexible">
                                <p>Subject to dispute, counterclaim, offset or defense</p>
                                <span class="text-truncate">................................................................................................................................................................</span>
                                <p class="numeric">{{0 | currency}}</p>
                            </div>
                        </li>
                        <li>
                            <div class="flexible">
                                <p>Not in lender&apos;s possession</p>
                                <span class="text-truncate">................................................................................................................................................................</span>
                                <p class="numeric">{{0 | currency}}</p>
                            </div>
                        </li>
                        <li>
                            <div class="flexible">
                                <p>Lender has not received the certificate of title for the financed auto</p>
                                <span class="text-truncate">................................................................................................................................................................</span>
                                <p class="numeric">{{0 | currency}}</p>
                            </div>
                        </li>
                        <li>
                            <div class="flexible">
                                <p>Not in full force and effect</p>
                                <span class="text-truncate">................................................................................................................................................................</span>
                                <p class="numeric">{{0 | currency}}</p>
                            </div>
                        </li>
                        <li>
                            <div class="flexible">
                                <p>Repayment shedule of more than {{form.get('term').value}} months</p>
                                <span class="text-truncate">................................................................................................................................................................</span>
                                <p class="numeric">{{0 | currency}}</p>
                            </div>
                        </li>
                    </ol>
                    <li>
                        <div class="flexible">
                            <p>Eligible Finance Contracts (Line 1 - Line 2)</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{balance(eligible.summary, null) | currency}}</p>
                        </div>
                    </li>
                    <li>
                        <div class="flexible">
                            <p>Borrowing Base {{form.get('percent').value}}% of line 3</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{(balance(eligible.summary, null) * (form.get('percent').value / 100)) | currency}}</p>
                        </div>
                    </li>
                    <li>
                        <div class="flexible">
                            <p>Commitment</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{commitment | currency}}</p>
                        </div>
                    </li>
                    <li>
                        <div class="flexible">
                            <p>Lesser of Line 4 or Line 5</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{lesser() | currency}}</p>
                        </div>
                    </li>
                    <li>
                        <div class="flexible">
                            <p>Amount of outstanding Advances</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{advances | currency}}</p>
                        </div>
                    </li>
                    <li>
                        <div class="flexible">
                            <p>Available Amount (Line 6 - Line 7)</p>
                            <span class="text-truncate">................................................................................................................................................................</span>
                            <p class="numeric">{{available() | currency}}</p>
                        </div>
                    </li>
                </ol>

                <p>
                    Attached hereto is a Finance Contract Report Showing Borrower's and Corporate
                    Guarantor&apos;s finance contract, designating Eligible Finance Contracts, and showing each
                    Finance Contract that does not satisfy the definition &quot;Eligible Finance Contracts&quot; for any
                    reason.
                </p>

                <section class="row signature">
                    <div class="col-4">
                        <form [formGroup]="form">
                            <div class="form-group form-row">
                                <div class="col-form-label col-3">
                                   <label for="dated">Date:</label>
                                </div>
                                <div class="col">
                                    <input type="date" id="report-dated" class="col clean" name="dated" formControlName="dated"/>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="col">
                        <p>BORROWER</p>
                        <p>{{summary.company}}</p>

                        <form>
                            <div class="form-group form-row">
                                <div class="col-form-label col-3">
                                   <label for="signature-by">By:</label>
                                </div>
                                <div class="col">
                                    <input type="text" id="signature-by" class="col clean" name="signature-by" />
                                </div>
                            </div>

                            <div class="form-group form-row">
                                <div class="col-form-label col-3">
                                   <label for="signature-name">Name:</label>
                                </div>
                                <div class="col">
                                    <input type="text" id="signature-name" class="col clean" name="signature-name" />
                                </div>
                            </div>

                            <div class="form-group form-row">
                                <div class="col-form-label col-3">
                                   <label for="signature-title">Title:</label>
                                </div>
                                <div class="col">
                                    <input type="text" id="signature-title" class="col clean" name="signature-title" />
                                </div>
                            </div>
                        </form>
                    </div>
                </section>

                @if (eligible && (eligible.summary.count > 0)) {
                    <hr />

                    <h4>Eligible Accounts</h4>

                    <ul class="list-group list-group-horizontal justify-content-center flexed">
                        <li class="list-group-item"><span>Total Number of Accounts</span> <span>{{eligible.summary.count | number: '1.0-0'}}</span></li>
                    </ul>

                    <p class="text-danger">NOTE: Payment amount, Payment Number and Number of payments left does not include deferred payments or last payments.</p>

                    <ul class="list-group justify-content-center flexed">
                        <li class="list-group-item"><span class="text-primary">Total Current {{summedBy}} Balance</span> <span>{{balance(eligible.summary, 'current') | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Total 30 Day {{summedBy}} Balance</span> <span>{{balance(eligible.summary, 'thirtyDay') | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Total 60 Day {{summedBy}} Balance</span> <span>{{balance(eligible.summary, 'sixtyDay') | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Total 90 Day {{summedBy}} Balance</span> <span>{{balance(eligible.summary, 'ninetyDay') | currency}}</span></li>
                        <li class="list-group-item item-total"><span>Total {{summedBy}} Balance</span> <span>{{balance(eligible.summary, null) | currency}}</span></li>
                    </ul>

                    <table class="table table-sm table-striped clickable">
                        <thead>
                            <tr>
                                <th scope="col">Account</th>
                                <th scope="col">Stock</th>
                                <th scope="col" class="text-right">Pmt. Amt</th>
                                <th scope="col" class="text-right">Mths.</th>
                                <th scope="col">Status</th>
                                <th scope="col" class="text-right">Original Financed</th>
                                <th scope="col" class="text-right">Days Late</th>
                                <th scope="col" class="text-right">Current (0-29)</th>
                                <th scope="col" class="text-right">30 Days (30-59)</th>
                                <th scope="col" class="text-right">60 Days (60-89)</th>
                                <th scope="col" class="text-right">90 Days and over</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (receivable of eligible.receivables; track receivable.id) {
                                <tr [routerLink]="['/accounts']" [queryParams]="{type: receivable.typeId, q: receivable.stock}">
                                    <td>{{receivable.contact}}</td>
                                    <td>{{receivable.stock}}</td>
                                    <td class="text-right">{{receivable.payment | currency}}</td>
                                    <td class="text-right">{{toMonths(receivable.periods, receivable.frequency) | number: '1.0-0'}}</td>
                                    <td>{{receivable.status}}</td>
                                    <td class="text-right">{{receivable.initialBalance | currency}}</td>
                                    <td class="text-right">{{receivable.daysPastDue | number: '1.0-0'}}</td>
                                    <td class="text-right">@if (receivable.daysPastDue < 30) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if ((receivable.daysPastDue >= 30) && (receivable.daysPastDue <= 69)) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if ((receivable.daysPastDue >= 60) && (receivable.daysPastDue <= 89)) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if (receivable.daysPastDue >= 90) { {{balance(receivable, null) | currency}} }</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }

                @if (ineligible && (ineligible.summary.count > 0)) {
                    <hr />

                    <h4>Ineligible Accounts</h4>

                    <ul class="list-group list-group-horizontal justify-content-center flexed">
                        <li class="list-group-item"><span>Total Number of Accounts</span> <span>{{ineligible.summary.count | number: '1.0-0'}}</span></li>
                    </ul>

                    <p class="text-danger">NOTE: Payment amount, Payment Number and Number of payments left does not include deferred payments or last payments.</p>

                    <ul class="list-group justify-content-center flexed">
                        <li class="list-group-item"><span class="text-primary">Total Current {{summedBy}} Balance</span> <span>{{balance(ineligible.summary, 'current') | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Total 30 Day {{summedBy}} Balance</span> <span>{{balance(ineligible.summary, 'thirtyDay') | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Total 60 Day {{summedBy}} Balance</span> <span>{{balance(ineligible.summary, 'sixtyDay') | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Total 90 Day {{summedBy}} Balance</span> <span>{{balance(ineligible.summary, 'ninetyDay') | currency}}</span></li>
                        <li class="list-group-item item-total"><span>Total {{summedBy}} Balance</span> <span>{{balance(ineligible.summary, null) | currency}}</span></li>
                    </ul>

                    <table class="table table-sm table-striped clickable">
                        <thead>
                            <tr>
                                <th scope="col">Account</th>
                                <th scope="col">Stock</th>
                                <th scope="col" class="text-right">Pmt. Amt</th>
                                <th scope="col" class="text-right">Mths.</th>
                                <th scope="col">Status</th>
                                <th scope="col" class="text-right">Original Financed</th>
                                <th scope="col" class="text-right">Days Late</th>
                                <th scope="col" class="text-right">Current (0-29)</th>
                                <th scope="col" class="text-right">30 Days (30-59)</th>
                                <th scope="col" class="text-right">60 Days (60-89)</th>
                                <th scope="col" class="text-right">90 Days and over</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (receivable of ineligible.receivables; track receivable.id) {
                                <tr [routerLink]="['/accounts']" [queryParams]="{type: receivable.typeId, q: receivable.stock}">
                                    <td>{{receivable.contact}}</td>
                                    <td>{{receivable.stock}}</td>
                                    <td class="text-right">{{receivable.payment | currency}}</td>
                                    <td class="text-right">{{toMonths(receivable.periods, receivable.frequency) | number: '1.0-0'}}</td>
                                    <td>{{receivable.status}}</td>
                                    <td class="text-right">{{receivable.initialBalance | currency}}</td>
                                    <td class="text-right">{{receivable.daysPastDue | number: '1.0-0'}}</td>
                                    <td class="text-right">@if (receivable.daysPastDue < 30) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if ((receivable.daysPastDue >= 30) && (receivable.daysPastDue <= 69)) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if ((receivable.daysPastDue >= 60) && (receivable.daysPastDue <= 89)) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if (receivable.daysPastDue >= 90) { {{balance(receivable, null) | currency}} }</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }

            }
        </main>
    }
</div>